(function ($) {
  var className;
  var count = 0;

  $.fn.subMenu = function (options) {
    var defaults = {
      hideAfter: 991,
      activeClass: "",
      animateTime: 800,
    };
    options = $.extend(defaults, options);
    var hide_after = options.hideAfter;
    var active_class = options.activeClass;
    var animate = options.animateTime;

    className = ".sticky-nav";
    var navHeight, stickyHeight, finalHeight, windowOffset, stickyOffset, addedValue = 0;
    navHeight = $('header').height();
    stickyHeight = $(className).outerHeight();

    if ($("body").hasClass("toolbar-tray-open")) {
      addedValue = 79;
    }
    finalHeight = navHeight + stickyHeight + addedValue;
    var navWithAdmin = navHeight + addedValue;
    windowOffset = $(window).scrollTop();
    stickyOffset = $(className).offset().top - navHeight;
    if (windowOffset > stickyOffset) {
      $(className).children().css({
        'position': 'fixed',
        'top': navWithAdmin
      }).addClass(active_class);

      if ($("header").hasClass("hide-nav")) {
        $('.sticky-nav').children().css({
          'position': 'fixed',
          'top': "0"
        });
      }
    }
    else {
      $(className).children().removeAttr('style').removeClass(active_class);
    }
    $($(this).find("a")).off().on('click', function (f) {
      if (this.hash !== "") {
        f.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top - finalHeight + 10
        }, animate, function () {
        });
      }
    });

    var scrollPos = $(window).scrollTop() + finalHeight + 10;
    $(className).find('li').removeClass("active");
    var refElement = '';

    $(className).find('a').each(function () {
      var href = $(this).attr("href");
      var hash = this.hash;
      refElement = hash ? $(hash) : $();
      if (href === "") {
        if (count === 0) {
          console.log("Please enter missing href");
          count++
        }
      }
      else {
        if (refElement.length && refElement.offset().top <= scrollPos && refElement.offset().top < scrollPos) {
          $(className).find('li').removeClass("active");
          $(this).parent().addClass("active");
        }
      }
    });
    var win_width = $(window).width();
    if (win_width <= hide_after) {
      $(className).hide();
    }
    else {
      $(className).show();
    }
  };
}(jQuery));
